import { render, staticRenderFns } from "./addCompanyAddress.vue?vue&type=template&id=4afa9884"
import script from "./addCompanyAddress.vue?vue&type=script&lang=js"
export * from "./addCompanyAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports